<template>
    <div>
        <app-page-header></app-page-header>
        <v-container  grid-list-xl class="box">
            <v-form id="form_rfid_user" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap align-center justify-center fill-height>
                    <v-flex xs12 sm12 md10 lg10 xl8>
                        <v-card id="form_card">
                            <v-card-title>
                                <v-icon left>mdi-clipboard-account</v-icon>
                                    <span class="subtitle-1 font-weight-regular application--card--title">Podatki o članu</span>
                                    <v-spacer></v-spacer>
                                <v-btn icon @click="card1 = !card1">
                                    <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-divider v-show="card1"></v-divider>
                            <!-- osebni podatki -->
                            <v-card-text v-show="card1">
                                <!-- backend validation messages -->
                                <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                                <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>
                                <br>

                                <v-row class="">
                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="col--dense--1">    
                                        <v-text-field
                                        v-model="firstname"
                                        label="Ime"
                                        required
                                        clearable
                                        :rules="firstname_rules"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="col--dense--1"> 
                                        <v-text-field
                                        v-model="lastname"
                                        label="Priimek"
                                        required
                                        clearable
                                        :rules="lastname_rules"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row class="">
                                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="col--dense--1">    
                                        <v-text-field
                                        v-model="address"
                                        label="Naslov"
                                        required
                                        clearable
                                        :rules="address_rules"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="col--dense--1">
                                        <v-text-field
                                        v-model="house_number"
                                        label="Hišna številka"
                                        required
                                        clearable
                                        :rules="house_number_rules"
                                        append-icon="mdi-pencil"
                                        type="number"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="col--dense--1">  
                                        <v-text-field
                                        v-model="house_number_addon"
                                        label="Dodatek k hišni številki"
                                        required
                                        clearable
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <!--<v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">-->
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-text-field
                                        v-model="town"
                                        label="Kraj"
                                        required
                                        clearable
                                        :rules="town_rules"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <span class="body-1 font-weight-regular">Spol</span>
                                        
                                        <v-radio-group v-model="gender_id" row :rules="gender_rules">
                                            <!--<v-radio label="Abonent" value="1"></v-radio>
                                            <v-radio label="Gost" value="2"></v-radio>-->
                                            <v-radio v-for="(item, index) in gender" :key="index" :value="item.id" :label="item.name"></v-radio>
                                        </v-radio-group>
                                    </v-col>

                                    <!--<v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">-->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-select
                                            v-model="postcode_id"
                                            :items="postcodes"
                                            label="Izberi pošto in poštno številko"
                                            chips
                                            clearable
                                            deletable-chips
                                            item-value="id"
                                            item-text="code_and_name"
                                            dense
                                            no-data-text="Ni podatkov za prikaz"
                                            class="pt-1"
                                            :rules="postcode_rules"
                                        ></v-select> 
                                    </v-col>
                                </v-row>
                                <v-row class="">
                                    <!--<v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">    -->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">  
                                        <v-text-field
                                        v-model="phone_number"
                                        label="Telefonska številka"
                                        required
                                        clearable
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>
                                    <!--<v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">-->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-text-field
                                        v-model="email"
                                        label="E-pošta"
                                        required
                                        clearable
                                        :rules="(email !== null && email.trim() !== '') ? email_rules : []"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>
                                    <!--<v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">  -->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-text-field
                                        v-model="tax_number"
                                        label="Davčna številka"
                                        required
                                        clearable
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <!-- podatki o članarini -->
                            <v-divider></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                            >   
                                <v-icon left>mdi-file-document-outline</v-icon>
                                <v-toolbar-title class="body-2">Podatki o članarini</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card2 = !card2">
                                    <v-icon>{{ card2 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider></v-divider>
                            <v-card-text v-show="card2">
                                
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <!-- aktivacija članarine -->
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Aktiviraj članarino</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-switch
                                                v-model="membership_active"
                                                :label="`Aktivni član: ${membershipActiveLabel}`"
                                                color="secondary"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>

                                    <!-- datum rojstva -->
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum rojstva</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_birth_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_birth_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_birth"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_birth_formatted"
                                                        label="Datum rojstva"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        clearable
                                                        :rules="date_of_birth_rules"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_birth')" v-model="date_of_birth" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- vrsta članarine -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi članarino</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="membershipFees"
                                                label="Izberi članarino"
                                                v-model="membership_fee"
                                                persistent-hint
                                                clearable
                                                item-text="name"
                                                item-value="id"
                                                no-data-text="Ni podatkov za prikaz"
                                                return-object
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                
                                <v-alert
                                text
                                outlined
                                color="deep-orange"
                                icon="mdi-information"
                                v-if="forbiddenMembershipFee"
                                >
                                
                                Nedovoljena članarina. Prekoračena starost člana ({{this.memberAge}} let) glede na izbrano članarino.

                                </v-alert>

                                <!-- vrsta člana
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi vrsto člana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="memberClassifications"
                                                label="Vrsta člana"
                                                item-text="name"
                                                item-value="id"
                                                v-model="member_classification_id"
                                                persistent-hint
                                                clearable
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>-->

                                <!-- tip člana -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi tip člana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="memberTypes"
                                                label="Tip člana"
                                                item-text="name"
                                                item-value="id"
                                                v-model="member_type_id"
                                                persistent-hint
                                                clearable
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>


                                <!-- datum pridružitve -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum pridružitve</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_registration_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_registration_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_registration"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_registration_formatted"
                                                        label="Datum pridružitve"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        clearable
                                                        :rules="date_of_registration_rules"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_registration')" v-model="date_of_registration" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- datum izstopa -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum izstopa</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_withdrawal_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_withdrawal_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_withdrawal"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_withdrawal_formatted"
                                                        label="Datum izstopa"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        clearable
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_withdrawal')" v-model="date_of_withdrawal" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- datum smrti -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum smrti</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_death_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_death_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_death"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_death_formatted"
                                                        label="Datum smrti"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        clearable
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_death')" v-model="date_of_death" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- vrsta izstopa -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi vrsto izstopa</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="withdrawalTypes"
                                                label="Vrsta izstopa"
                                                item-text="name"
                                                item-value="id"
                                                v-model="withdrawal_type_id"
                                                persistent-hint
                                                clearable    
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- opomba -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Opombe</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="Opombe"
                                            v-model="note"
                                            counter
                                            required
                                            class="mt-6"
                                            clearable
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <!-- podatki o kartici -->
                            <v-divider></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                            >   
                                <v-icon left>mdi-credit-card-wireless-outline</v-icon>
                                <v-toolbar-title class="body-2">Podatki o kartici</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card3 = !card3">
                                    <v-icon>{{ card3 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider></v-divider>
                            <v-card-text v-show="card3">
                                <v-container grid-list-xl class="container--dense-2">
                                <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center class="container--dense-1">
                                            <v-subheader class="pt-7 pl-0"><strong>ID kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center class="container--dense-1">
                                            <v-text-field
                                                v-model="card_id"
                                                label="ID kartice"
                                                required
                                                :disabled="!card_id_input_enabled"
                                                ref="cardId"
                                                :rules="getCardNumber ? card_id_rules : []"
                                                append-icon="mdi-tag-text-outline"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center class="container--dense-1">
                                            <v-subheader class="pt-7 pl-0"><strong>Serijska številka kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center class="container--dense-1">
                                            <v-text-field
                                                v-model="card_number"
                                                label="Serijska št. kartice"
                                                required
                                                :disabled="!card_number_input_enabled"
                                                ref="cardNumber"
                                                @keyup.enter.native="RfidNr"
                                                append-icon="mdi-numeric"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center class="container--dense-1">
                                            <v-subheader class="pt-7 pl-0"><strong>Kartica blokirana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center class="container--dense-1">
                                            <v-switch
                                                v-model="card_blocked"
                                                :label="`Blokiraj kartico: ${cardBlocked}`"
                                                color="secondary"
                                                value="1"
                                                hide-details
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-left v-if="$vuetify.breakpoint.lgAndUp">
                                            <v-subheader><strong></strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-left>
                                            <v-btn class="btn_rfid" small :block="$vuetify.breakpoint.xsOnly" :disabled="storeItemLoading " :loading="scanRfidLoading" color="success" @click="enableRfidCardInput"><v-icon small left>mdi-wifi</v-icon>Klikni tukaj za skeniranje</v-btn>
                                            &nbsp;&nbsp;
                                            <v-btn class="btn_rfid" small :block="$vuetify.breakpoint.xsOnly" :disabled="scanRfidLoading ||storeItemLoading" color="error" @click="removeRfidCard"><v-icon small left>mdi-close</v-icon>Odstrani kartico</v-btn>
                                            <!--&nbsp;&nbsp;
                                            <v-btn class="btn_rfid" small :block="$vuetify.breakpoint.xsOnly" :disabled="scanRfidLoading ||storeItemLoading || card_entrance_limit == null" color="info" @click="cardEntranceQuotaReset()"><v-icon small left>mdi-refresh</v-icon>Ponastavi števec vstopov</v-btn>-->
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <!-- plačilo članarine -->
                            <v-divider v-if="member_uuid !== null && member_uuid !== '' && member !== null"></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                                v-if="member_uuid !== null && member_uuid !== '' && member !== null"
                            >   
                                <v-icon left>mdi-cash</v-icon>
                                <v-toolbar-title class="body-2">Plačilo članarine</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card4 = !card4">
                                    <v-icon>{{ card4 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider v-if="member_uuid !== null && member_uuid !== '' && member !== null"></v-divider>
                            <v-card-text v-show="card4" v-if="member_uuid !== null && member_uuid !== '' && member !== null">
                                <!--<v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Izberi leto za plačilo</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                            :items="years"
                                            label="Izberi leto"
                                            v-model="membership_fee_payment_year"
                                            persistent-hint
                                            clearable
                                        ></v-select>
                                    </v-flex>
                                </v-layout>

                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-left v-if="$vuetify.breakpoint.lgAndUp">
                                        <v-subheader><strong></strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-left>
                                        <v-btn class="btn_rfid" small :block="$vuetify.breakpoint.xsOnly" :disabled="storeItemLoading || (membership_fee_payment_year == null || membership_fee_payment_year == '' || membership_fee == null || membership_fee == '')" :loading="paymentLoading" color="info" @click="payMembershipFee()"><v-icon small left>mdi-account-cash-outline</v-icon>Plačilo članarine</v-btn>
                                    </v-flex>
                                </v-layout>-->

                                <div style="min-height:20px;"></div>
                                <v-layout justify-center>
                                    <v-card-actions>
                                        <v-btn :block="$vuetify.breakpoint.xsOnly" :disabled="storeItemLoading || (membership_fee_payment_year == null || membership_fee_payment_year == '' || membership_fee == null || membership_fee == '')" :loading="paymentLoading" color="info" @click="payMembershipFee()"><v-icon small left>mdi-account-cash-outline</v-icon>Plačilo članarine</v-btn>
                                    </v-card-actions>
                                </v-layout>
                                <div style="min-height:20px;"></div>
                                
                                <v-alert
                                v-if="membership_fee_payment_year == null || membership_fee_payment_year == '' || membership_fee == null || membership_fee == ''"
                                text
                                outlined
                                color="deep-orange"
                                icon="mdi-information"
                                >
                                Plačilo ni mogoče. Plačilo bo mogoče, ko boste določili vrsto članarine in leto, za katerega se plačuje članarina.
                                </v-alert>

                            </v-card-text>


                            <!-- podatki o plačilu -->
                            <v-divider v-if="membership_fee_payment_year !== null && selectedMembers.length > 0 && selectedPayer.length > 0 && membership_fee !== null"></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                                v-if="membership_fee_payment_year !== null && selectedMembers.length > 0 && selectedPayer.length > 0 && membership_fee !== null"
                            >   
                                <v-icon left>mdi-file-document-outline</v-icon>
                                <v-toolbar-title class="body-2">Povzetek za plačilo članarine</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card5 = !card5">
                                    <v-icon>{{ card5 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider v-if="membership_fee_payment_year !== null && selectedMembers.length > 0 && selectedPayer.length > 0 && membership_fee !== null"></v-divider>
                            <v-card-text v-if="membership_fee_payment_year !== null && selectedMembers.length > 0 && selectedPayer.length > 0 && membership_fee !== null" v-show="card5">
                                <payment-info :data="paymentInfoData"></payment-info>
                                <br v-if="paymentDone"> 
                                <v-alert v-if="paymentDone"
                                    outlined
                                    type="success"
                                    text
                                    dense
                                    dismissible
                                    >
                                    Plačilo članarine je bilo uspešno zavedeno.
                                    </v-alert>
                            </v-card-text>

                            <v-divider></v-divider>
                            <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                                <v-btn block outlined style="margin-bottom:10px;" @click="submitForm()" color="success" :disabled="loading || member_created"><v-icon left>mdi-arrow-right</v-icon>{{ btnSubmitFormTitle }}</v-btn>
                                <v-btn block outlined style="margin-bottom:10px;" @click="clearForm()" color="warning"><v-icon left>mdi-refresh</v-icon>{{ btnCancelFormTitle }}</v-btn>
                            </v-card-text>
                            <v-card-text v-else>
                                <v-btn @click="submitForm()" color="success" text :disabled="loading ||member_created"><v-icon left>mdi-arrow-right</v-icon>{{ btnSubmitFormTitle }}</v-btn>
                                <v-btn @click="clearForm()" color="warning" text><v-icon left>mdi-refresh</v-icon>{{ btnCancelFormTitle }}</v-btn>
                            </v-card-text>

                        </v-card>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>

        <membership-fee-payment></membership-fee-payment>
    </div>

</template>

<script>
import { EventBus } from '@/main.js'
import { formatDate, randomPinNumber, getCurrentDate } from '@/helpers/utilities.js'
const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')
const MembershipFeePayment = () => import('@/components/MembershipFeePayment.vue')
const PaymentInfo = () => import('@/components/PaymentInfo.vue')

export default {
    components: {
        FormValidationMessages,
        FormSubmitMessages,
        MembershipFeePayment,
        PaymentInfo
    },

    data: () => ({
        valid: true,
        form: true,
        card1: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,
        card6: true,
        card7: true,
        card8: true,
        ndef: null,
        aborController: null,
        currentYear: null,
        forbiddenMembershipFee: false,
        memberAge: null,


        paymentDone: false,
        member: null,

        loading: false,
        member_created: false,
        storeItemLoading: false,
        scanRfidLoading: false,
        paymentLoading: false,

        member_uuid: null,
        firstname: null,
        lastname: null,
        address: null,
        house_number: null,
        house_number_addon: null,
        postcode_id: null,
        town: null,
        gender_id: null,
        phone_number: null,
        email: null,
        tax_number: null,
        membership_active: false,
        date_of_birth: null,
        member_type_id: null,
        member_classification_id: null,
        date_of_registration: null,
        date_of_withdrawal: null,
        date_of_death: null,
        withdrawal_type_id: null,
        note: null,
        card_id: null,
        card_number: null,
        card_scan_input: null,
        card_blocked: false,
        membership_fee_payment_year: null,
        membership_fee: null,

        date_of_birth_menu: false,
        date_of_registration_menu: false,
        date_of_withdrawal_menu:false,
        date_of_death_menu: false,

        date_of_birth_formatted: null,
        date_of_registration_formatted: null,
        date_of_withdrawal_formatted: null,
        date_of_death_formatted: null,

        card_number_input_enabled: false,
        card_id_input_enabled: false,

        selectedPayer: [],
        selectedMembers: [],

        postcodes: [],
        gender: [],
        memberTypes: [],
        memberClassifications: [],
        withdrawalTypes: [],
        years: [],
        membershipFees: [],

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[],

        //rules
        firstname_rules: [v => !!v || 'Polje ime je obvezno'],
        lastname_rules: [v => !!v || 'Polje priimek je obvezno'],
        address_rules: [v => !!v || 'Polje naslov je obvezno'],
        house_number_rules: [v => !!v || 'Polje hišna številka je obvezno'],
        town_rules: [v => !!v || 'Polje kraj je obvezno'],
        gender_rules: [v => !!v || 'Polje spol je obvezno'],
        postcode_rules: [v => !!v || 'Polje poštna številka je obvezno'],
        card_id_rules: [
            v => (!!v) || 'Vnos ID kartice je obvezen!',
        ],

        email_rules: [(v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vneseni elektronski naslov ni veljaven.'],
        date_of_birth_rules: [v => !!v || 'Polje datum rojstva je obvezno'],
        date_of_registration_rules: [v => !!v || 'Polje datum pridružitve je obvezno']


    }),

    watch: {
        date_of_birth(val) {
            this.date_of_birth_formatted = formatDate(val)
            this.checkMembershipFee();
        },

        date_of_registration(val) {
            this.date_of_registration_formatted = formatDate(val)
        },

        date_of_withdrawal(val) {
            this.date_of_withdrawal_formatted = formatDate(val)
        },

        date_of_death(val) {
            this.date_of_death_formatted = formatDate(val)
        },

        membership_fee(val) {
            this.checkMembershipFee();
        },

    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        },

        btnSubmitFormTitle() {
            if(this.$vuetify.breakpoint.smAndDown) {
                return 'Shrani'
            }

            return 'Dodaj člana'
        },

        btnCancelFormTitle() {
            if(this.$vuetify.breakpoint.smAndDown) {
                if(this.member_created) {
                    return 'Zaključi'
                }
            }

            if(this.member_created) {
                return 'Zaključi'
            }

            return 'Prekliči'
        },

        cardBlocked() {
            if(this.card_blocked) {
                return 'DA'
            }

            return 'NE'
        },

        getCardNumber() {
           if(this.card_number == null || this.card_number == '') return false

           return true
        },

        cardIdValue() {
            return this.card_id
        },

        membershipActiveLabel() {
            if(this.membership_active) {
                return 'DA'
            }

            return 'NE'
        },

        paymentInfoData() {

            return {
                year: this.membership_fee_payment_year,
                selectedPayer: this.selectedPayer,
                selectedMembers: this.selectedMembers,
                selectedMembershipFee: this.membership_fee
            }
        }
    },

    methods: {
        dateMenuSave(parameter) {
            if(parameter == 'date_of_birth') {
                this.$refs.date_of_birth_menu.save(this.date_of_birth)
                this.date_of_birth_menu = false
            }

            if(parameter == 'date_of_registration') {
                this.$refs.date_of_registration_menu.save(this.date_of_registration)
                this.date_of_registration_menu = false
            }

            if(parameter == 'date_of_withdrawal') {
                this.$refs.date_of_withdrawal_menu.save(this.date_of_withdrawal)
                this.date_of_withdrawal_menu = false
            }

            if(parameter == 'date_of_death') {
                this.$refs.date_of_death_menu.save(this.date_of_death)
                this.date_of_death_menu = false
            }

        },

        submitForm() {
            var vm = this
            if(this.$refs.form.validate()) {

                this.backendValidationMessages = []
                this.backendMessages = []
                this.backendErrorMessages = []

                vm.$store.commit('SET_PROGRESS', true)
                vm.storeItemLoading = true
                vm.$store.commit('SET_LOADER_TEXT', 'Kreiranje člana je v teku...')
                vm.$store.commit('SET_LOADER', true)

                let submitData = {
                    firstname: vm.firstname,
                    lastname: vm.lastname,
                    name: vm.firstname + " " + vm.lastname,
                    address: vm.address,
                    house_number: vm.house_number,
                    house_number_addon: vm.house_number_addon,
                    postcode_id: vm.postcode_id,
                    town: vm.town,
                    gender_id: vm.gender_id,
                    phone_number: vm.phone_number,
                    email: vm.email,
                    tax_number: vm.tax_number,
                    membership_active: (vm.membership_active == true || vm.membership_active == 1) ? 1 : 0,
                    date_of_birth: vm.date_of_birth,
                    membership_fee_id: vm.membership_fee.id,
                    member_type_id: vm.member_type_id,
                    member_classification_id: vm.member_classification_id,
                    date_of_registration: vm.date_of_registration,
                    date_of_withdrawal: vm.date_of_withdrawal,
                    date_of_death: vm.date_of_death,
                    withdrawal_type_id: vm.withdrawal_type_id,
                    card_id: vm.card_id,
                    card_number: vm.card_number,
                    card_blocked: (vm.card_blocked == true || vm.card_blocked == 1) ? 1 : 0,
                    card_scan_input: vm.card_scan_input,
                    membership_fee_payment_year: vm.membership_fee_payment_year,
                    note: vm.note
                }

                vm.$store.dispatch('CREATE_MEMBER', submitData)
                .then(response => {
                    window.console.log(response.data)
                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarText', "Uporabnik je bil uspešno vnesen v sistem.")
                    vm.$store.commit('snackbarMode', '')
                    vm.$store.commit('snackbarTimeout', 7000)
                    vm.$store.commit('snackbarDisplay', true)

                    //vm.clearForm()
                    vm.member_created = true
                    vm.backendMessages.push('Uporabnik je bil uspešno vnesen v sistem.');

                    vm.member = response.data.data;
                    if(vm.member !== null) {
                        vm.member_uuid = response.data.data.uuid;
                        vm.selectedPayer.push(vm.member)
                        vm.selectedMembers.push(vm.member)

                        const d = new Date();
                        let year = d.getFullYear();
                        vm.membership_fee_payment_year = year
                    }

                })
                .catch(error => {
                    console.log('CREATE RFID MEMBER error')
                    console.log(error)
                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarMode', 'multi-line')
                    vm.$store.commit('snackbarText', 'Pri vnašanju člana v sistem je prišlo do napake. Prosimo poskusite ponovno.')
                    vm.$store.commit('snackbarDisplay', true)

                    if(error.response.status === 422) {
                        window.console.log(error.response.data.errors)
                        for (const property in error.response.data.errors) {
                            //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                            var propertyData = error.response.data.errors[property];
                            //window.console.log(propertyData);
                            propertyData.forEach(message => {
                                vm.backendValidationMessages.push(message);
                            })

                            setTimeout(() => {
                                vm.$vuetify.goTo('#form_card', {
                                    duration: 1000,
                                    offset: 0,
                                    easing: 'easeInOutCubic'
                                })
                            }, 200)
                        }
                    } else {
                        vm.backendErrorMessages.push('Ups... pri zapisovanju člana je prišlo do napake. Poskusite ponovno.')
                        setTimeout(() => {
                            vm.$vuetify.goTo('#form_card', {
                                duration: 1000,
                                offset: 0,
                                easing: 'easeInOutCubic'
                            })
                        }, 200)
                    }

                })
                .finally(() => {
                    setTimeout(() =>{
                        vm.storeItemLoading = false;
                        vm.$store.commit('SET_PROGRESS', false)
                        vm.$store.commit('SET_LOADER', false)
                        vm.$store.commit('SET_LOADER_TEXT', '')
                    },600)
                })

                // dispatch API call
                //window.console.log("data:")
                //window.console.log(submitData)

                /*setTimeout(() =>{
                    vm.storeItemLoading = false;
                    vm.$store.commit('SET_PROGRESS', false)
                    vm.$store.commit('SET_LOADER', false)
                    vm.$store.commit('SET_LOADER_TEXT', '')
                    vm.backendMessages.push('Uporabnik je bil uspešno vnesen v sistem.');
                    vm.member_uuid = '123-456-789';
                },1600)*/


            } else {
                setTimeout(() => {
                    vm.$vuetify.goTo('#form_card', {
                        duration: 1000,
                        offset: 0,
                        easing: 'easeInOutCubic'
                    })
                }, 200)
            }
            
        },

        payMembershipFee() {
            let vm = this
            let paymentData = {
                payer_id: vm.member.id,
                payer_uuid: vm.member_uuid,
                data: [
                    {
                        member_id: vm.member.id,
                        member_uuid: vm.member_uuid,
                        membership_fee_year: vm.membership_fee_payment_year,
                        membership_fee_id: vm.membership_fee.id,
                        membership_fee: vm.membership_fee
                    }
                ]

            }

            EventBus.$emit('MEMBERSHIP_FEE_PAYMENT_DIALOG', paymentData);
            window.console.log("### AddMember@payMembershipFee ###");
            window.console.log(paymentData);
        },

        clearBackendMessages() {
            this.backendValidationMessages = []
            this.backendMessages = []
            this.backendErrorMessages = []
        },

        clearForm() {
            this.$refs.form.resetValidation();
            this.setDefaultFormValues()
            this.clearBackendMessages()
        },

        setDefaultFormValues() {
            this.member_uuid = null
            this.membership_fee_payment_year = null
            this.membership_fee = null
            this.firstname = null
            this.lastname =  null
            this.address =  null
            this.house_number =  null
            this.house_number_addon =  null
            this.postcode_id =  null
            this.town =  null
            this.gender_id =  null
            this.phone_number =  null
            this.email =  null
            this.tax_number =  null
            this.membership_active = false
            this.date_of_birth =  null
            this.member_type_id =  null
            this.member_classification_id =  null
            this.date_of_registration =  null
            this.date_of_withdrawal =  null
            this.date_of_death =  null
            this.withdrawal_type_id =  null
            this.note =  null
            this.removeRfidCard()
            this.membership_fee = null
            this.selectedMembers = []
            this.selectedPayer = []
            this.paymentDone = false
            this.membership_fee_payment_year = null


            this.member_created = false
        },

        removeRfidCard() {
            this.card_id = null;
            this.card_number = null;
            this.card_scan_input = null;
            this.card_blocked = null;
            //this.card_type_id = null;
            this.card_id_input_enabled = false;
            this.card_number_input_enabled = false;
            //this.$refs.form.validate();
            this.$refs.cardId.blur();
            this.$refs.cardNumber.blur();
        },

        enableRfidCardInput() {
            this.removeRfidCard()
            this.card_number_input_enabled = true

            setTimeout(() => {
                this.$refs.cardNumber.focus()
            }, 350)
        },

        rfidCardSet() {
            if(this.card_id != null && this.card_id != '' && this.card_number != null && this.card_number != "")
            {
                return true
            }

            return false
        },

        RfidNr() {
            let data = this.card_number
            this.card_scan_input = this.card_number
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)
            this.scanRfidLoading = true

            this.scanRfidLoading = false
            vm.$store.commit('SET_SNACKBAR_DISPLAY', false)
            vm.$store.commit('SET_SNACKBAR_TEXT', "Kartica uspešno poskenirana. Serijska številka kartice: " +  this.card_scan_input + ". Vpišite še ID kartice.")
            vm.$store.commit('SET_SNACKBAR_MODE', 'multi-line')
            vm.$store.commit('SET_SNACKBAR_TIMEOUT', 7000)
            vm.$store.commit('SET_SNACKBAR_DISPLAY', true)

            this.card_id_input_enabled = true
            setTimeout(() => {
                    vm.$refs.cardId.focus()
            }, 350)

            this.card_number_input_enabled = false
        },

        /*global NDEFReader*/
        async ndefReader() {
            let vm = this
            window.console.log("NDEFReader ....")
            try {
                if('NDEFReader' in window) {
                    vm.aborController = new AbortController();
                    vm.ndef = new NDEFReader();

                    //await vm.ndef.scan({ signal: vm.abortController.signal });
                    await vm.ndef.scan();
                    window.console.log("> Scan started");

                    vm.ndef.addEventListener("readingerror", () => {
                        window.console.log("Argh! Cannot read data from the NFC tag. Try another one?");
                    });

                    vm.ndef.addEventListener("reading", ({ message, serialNumber }) => {
                        window.console.log(`> Serial Number: ${serialNumber}`);
                        window.console.log(`> Records: (${message.records.length})`);

                        vm.card_scan_input = null
                        vm.card_number = null

                        if(vm.card_number_input_enabled) {
                            vm.card_number = serialNumber
                            vm.card_scan_input = serialNumber
                            vm.card_number_input_enabled = false
                            vm.card_id_input_enabled = true
                            setTimeout(() => {
                                vm.$refs.cardId.focus()
                                //vm.aborController.abort();
                            }, 250)
                        }
                
                    });
                }
            } catch (error) {
                window.console.log("Argh! " + error);
            }
        },

        checkMembershipFee() {
            let selectedMembershipFee = this.membership_fee;
            let selectedDateOfBirth = this.date_of_birth;

            if(selectedMembershipFee !== null && selectedDateOfBirth !== null) {
                this.memberAge = this.currentYear - parseInt(selectedDateOfBirth);
                //window.console.log("Starost: " + this.memberAge);
                if(selectedMembershipFee.id == 3 || selectedMembershipFee.id == 4) { // če je otroška članarina
                    if(this.memberAge > 18) {
                        this.forbiddenMembershipFee = true
                    } else {
                        this.forbiddenMembershipFee = false
                    }
                } else {
                    this.forbiddenMembershipFee = false
                }
            } else {
                this.forbiddenMembershipFee = false;
            }

            //window.console.log("Forbidden Membership Fee: " + this.forbiddenMembershipFee);
        }
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        /*
        this.member_uuid = "123"
        this.member = {
            id: 1
        }
        */
        

        const d = new Date();
        let year = d.getFullYear();
        this.membership_fee_payment_year = year
        this.currentYear = d.getFullYear();
    },

    mounted() {
        var vm = this
        vm.$store.commit('SET_PROGRESS', true)
        vm.$store.dispatch('PARAMETERS_DATA')
        .then(response => {
            //window.console.log(response.data)
            vm.gender = response.data.gender
            vm.postcodes = response.data.postcodes
            vm.memberTypes = response.data.memberTypes
            vm.memberClassifications = response.data.memberClassifications
            vm.withdrawalTypes = response.data.withdrawalTypes
            vm.years = response.data.years
            vm.membershipFees = response.data.membershipFees

            let defaultMemberType = process.env.VUE_APP_DATA_DEFAULT_MEMBER_TYPE || 1;
            setTimeout(() => {
                vm.member_type_id = defaultMemberType
                vm.member_type_id = 1
            }, 250)

            vm.memberClassifications.forEach(mc => {
                if(mc.current == 1 || mc.current == true) {
                    vm.member_classification_id = mc.id
                }
            })
        })
        .catch(error => {
            window.console.error("### ERROR AddMember.vue@mounted ###");
            window.console.error(error)
        })
        .finally(() => {
            vm.$store.commit('SET_PROGRESS', false)
        })

        EventBus.$on('MEMBERSHIP_FEE_PAYMENT_CONFIRMATION', (data) => {
            window.console.log("### MEMBERSHIP_FEE_PAYMENT_CONFIRMATION ###");
            window.console.log(data);
        })

        EventBus.$on('MEMBERSHIP_FEE_PAYMENT_DIALOG_CLOSE', (data) => {
            window.console.log("Membership Fee Payment Dialog Close")
            window.console.log(data)
            if(data.paymentDone) {
                this.paymentDone = true
            } else {
                this.paymentDone = false
            }
        })

        this.ndefReader();
    },

    beforeDestroy() {
        EventBus.$off('MEMBERSHIP_FEE_PAYMENT_CONFIRMATION');
        EventBus.$off('MEMBERSHIP_FEE_PAYMENT_DIALOG_CLOSE')

        //const abortController = new AbortController();
    },

     destroyed() {
         this.ndef = null;
         this.abortController = null
     }
}

</script>

<style scoped>
    .btn_rfid {
        margin-right:10px;
        margin-bottom: 15px;
    }
</style>